import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseCodePolicy extends BasePolicy {
    /**
     *
     * @param user
     * @returns {*}
     */
    viewAny(user) {
        return user.hasPermissionTo('view a course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    create(user) {
        return user.hasPermissionTo('create a course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    update(user) {
        return user.hasPermissionTo('edit a course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    delete(user) {
        return user.hasPermissionTo('delete a course code');
    }
}
